/******/ (() => { // webpackBootstrap
/******/ 	"use strict";

;// ./src/styles/bundles/templates/index.css
// extracted by mini-css-extract-plugin

;// ./src/js/bundles/templates/index.js

/******/ })()
;